import React from 'react';
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import {
  FaCloud,
  FaShieldAlt,
  FaServer,
  FaCode,
  FaUsersCog,
  FaGraduationCap
} from "react-icons/fa";
import './Experience.css';

export const Experience = () => {
  return (
    <section className="experience" id="experience">
      <Container>
        <h2>Professional Journey</h2>
        <p className="section-subtitle">My career experience and academic background</p>
        
        <Tab.Container id="experience-tabs" defaultActiveKey="experience">
          <Nav variant="pills" className="mb-5 justify-content-center">
            <Nav.Item>
              <Nav.Link eventKey="experience">Experience</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="education">Education</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="highlights">Highlights</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            {/* Experience Tab */}
            <Tab.Pane eventKey="experience">
              <div className="timeline">
                {/* Current Position */}
                <div className="timeline-item current">
                  <div className="timeline-header">
                    <h3>System Administrator</h3>
                    <h4>Outspan Global University | May 2025 - Present | Kenya</h4>
                    <div className="current-badge">Current Position</div>
                  </div>
                  <ul>
                    <li>Manage and maintain university-wide IT infrastructure, including servers, networks, and end-user systems</li>
                    <li>Administer and monitor server environments to ensure uptime, performance, and data integrity</li>
                    <li>Implement IT security policies, access controls, and best practices to protect institutional systems</li>
                    <li>Provide technical support and troubleshooting for staff and students across departments</li>
                  </ul>
                </div>

                {/* Previous Position */}
                <div className="timeline-item">
                  <div className="timeline-header">
                    <h3>Client Based Software Developer</h3>
                    <h4>Amilda Wellness Boutique | 2023 - 2025 | Amsterdam, Netherlands</h4>
                  </div>
                  <ul>
                    <li>Maintained and optimized 20+ client email templates in Ovatu CRM</li>
                    <li>Improved client engagement rate by 35% through personalized communication strategies</li>
                    <li>Developed new CRM features to enhance customer experience and retention</li>
                    <li>Resolved technical issues within 24-hour SLA for 50+ business clients</li>
                  </ul>
                </div>

                {/* Previous Position */}
                <div className="timeline-item">
                  <div className="timeline-header">
                    <h3>Platform Developer (Contract)</h3>
                    <h4>DigitalQatalyst | 05/2024 - 01/2025 | Dubai, UAE</h4>
                  </div>
                  <ul>
                    <li>Architected and deployed 5 major enterprise platforms (DTMA, Tmaas, DTMP, DFSA, Invest UAU) using Power Platform</li>
                    <li>Reduced deployment time by 40% through implementation of automated CI/CD pipelines in Azure DevOps</li>
                    <li>Increased platform performance by 35% through optimization of React and TypeScript codebase</li>
                    <li>Led a team of 8 developers across multiple projects, maintaining 98% on-time delivery rate</li>
                  </ul>
                </div>

                {/* Internship Positions */}
                <div className="timeline-item">
                  <div className="timeline-header">
                    <h3>Full-Stack Developer (Intern)</h3>
                    <h4>The Jitu Company | 05/2023 - 12/2023 | Nyeri, Kenya</h4>
                  </div>
                  <ul>
                    <li>Developed 4 e-commerce platforms serving 50,000+ monthly active users using React, Redux, and TypeScript</li>
                    <li>Improved system response time by 45% through optimization of Azure database solutions</li>
                    <li>Reduced page load time by 60% through implementation of React performance best practices</li>
                  </ul>
                </div>
              </div>
            </Tab.Pane>

            {/* Education Tab */}
            <Tab.Pane eventKey="education">
              <div className="timeline">
                <div className="timeline-item current">
                  <div className="timeline-header">
                    <h3>Cyber Security Program</h3>
                    <h4>ALX Africa | March 2026 - October 2026 | Remote</h4>
                    <div className="current-badge">In Progress</div>
                  </div>
                  <ul>
                    <li>Intensive program covering threat detection, network security, and security operations</li>
                    <li>Hands-on labs in vulnerability assessment, incident response, and secure system design</li>
                  </ul>
                </div>

                <div className="timeline-item">
                  <div className="timeline-header">
                    <h3>Professional DevOps Engineering</h3>
                    <h4>Moringa School | March 2025 - June 2025 | Remote</h4>
                  </div>
                  <ul>
                    <li>Focused training in CI/CD pipelines, containerization, and cloud infrastructure automation</li>
                    <li>Practical projects covering Docker, Kubernetes, and infrastructure-as-code workflows</li>
                  </ul>
                </div>

                <div className="timeline-item">
                  <div className="timeline-header">
                    <h3>Bachelor of Science in Computer Science</h3>
                    <h4>Kirinyaga University | 01/2020 - 12/2024 | Kerugoya, Kenya</h4>
                  </div>
                  <ul>
                    <li>Specialization: Full-Stack Development and Cybersecurity</li>
                    <li>Final Year Project: AI-Based Weather Pattern classification and forecasting System</li>
                    <li>Coursework: Cloud Computing, Data Structures, Machine Learning, Secure Coding</li>
                  </ul>
                </div>

                <div className="timeline-item">
                  <div className="timeline-header">
                    <h3>Full-Stack Software Engineering Program</h3>
                    <h4>ALX Holberton School | 01/2022 - 01/2023 | Remote</h4>
                  </div>
                  <ul>
                    <li>Completed 1,500+ hours of intensive software engineering training</li>
                    <li>Led 3 capstone projects with average grade of 95%</li>
                    <li>Technologies: Python, JavaScript, React, Node.js, Databases</li>
                  </ul>
                </div>
              </div>
            </Tab.Pane>

            {/* Highlights Tab */}
            <Tab.Pane eventKey="highlights">
              <Row className="achievements-grid">
                <Col md={4} sm={6}>
                  <div className="achievement-card highlight-card">
                    <div className="highlight-icon"><FaCloud /></div>
                    <div className="achievement-title">Multi-Cloud Operations</div>
                    <p>Hands-on experience across Azure, AWS, and Power Platform environments</p>
                  </div>
                </Col>

                <Col md={4} sm={6}>
                  <div className="achievement-card highlight-card">
                    <div className="highlight-icon"><FaShieldAlt /></div>
                    <div className="achievement-title">Security-First Mindset</div>
                    <p>DevSecOps practices woven into every pipeline, from code to deployment</p>
                  </div>
                </Col>

                <Col md={4} sm={6}>
                  <div className="achievement-card highlight-card">
                    <div className="highlight-icon"><FaServer /></div>
                    <div className="achievement-title">Systems & Infrastructure</div>
                    <p>Comfortable managing servers, networks, and critical IT operations end-to-end</p>
                  </div>
                </Col>

                <Col md={4} sm={6}>
                  <div className="achievement-card highlight-card">
                    <div className="highlight-icon"><FaCode /></div>
                    <div className="achievement-title">Full-Stack Engineering</div>
                    <p>Building with React, TypeScript, and modern back-end frameworks</p>
                  </div>
                </Col>

                <Col md={4} sm={6}>
                  <div className="achievement-card highlight-card">
                    <div className="highlight-icon"><FaUsersCog /></div>
                    <div className="achievement-title">Cross-Functional Leadership</div>
                    <p>Led development teams and supported end-users across multiple organizations</p>
                  </div>
                </Col>

                <Col md={4} sm={6}>
                  <div className="achievement-card highlight-card">
                    <div className="highlight-icon"><FaGraduationCap /></div>
                    <div className="achievement-title">Always Learning</div>
                    <p>Continuously expanding expertise through DevOps and cybersecurity certifications</p>
                  </div>
                </Col>
              </Row>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Container>
    </section>
  );
};
